/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions } from '@react-navigation/native'
import Constants from 'expo-constants'
import { createURL } from 'expo-linking'
import { Platform } from 'react-native'

import { WEB } from '~constants'
import { Routes } from '~types/routesNames'
const prefix = createURL('/')
const universalLinks = Constants.manifest?.extra?.universalLinks ?? []

const WEB_LINKS_CONFIG: LinkingOptions<RootStackParamList>['config'] = {
  initialRouteName: Routes.MainTab,
  screens: {
    MainTab: {
      // @ts-expect-error: react navigation works differently on web and it's hard to add types that satisfy web and mobile
      initialRouteName: Routes.OffersList,
      screens: {
        // @ts-expect-error: react navigation works differently on web and it's hard to add types that satisfy web and mobile
        [Routes.History]: '/history',
        [Routes.OffersList]: '/',
        [Routes.UserProfile]: '/user',
      },
    },
    [Routes.NftDetails]: '/nft',
    [Routes.OfferDetails]: '/offer',
    [Routes.UserDetailsForm]: '/user/edit',
    [Routes.SignIn]: '/sign-in',
    [Routes.SignUp]: '/sign-up',
    ApplicationInfo: '/application-info',
    NotFound: '*',
  },
}
const APP_LINKS_CONFIG: LinkingOptions<RootStackParamList>['config'] = {
  initialRouteName: Routes.MainTab,
  screens: {
    MainTab: {
      initialRouteName: Routes.OffersStack,
      screens: {
        OffersStack: {
          // @ts-expect-error: problem with react navigation wich expects undefined as initialRouteName
          initialRouteName: Routes.OffersList,
          screens: {
            OffersList: '/',
          },
        },
        UserStack: {
          // @ts-expect-error: problem with react navigation wich expects undefined as initialRouteName
          initialRouteName: Routes.UserProfile,
          screens: {
            UserProfile: '/user',
          },
        },
        HistoryStack: {
          // @ts-expect-error: problem with react navigation wich expects undefined as initialRouteName
          initialRouteName: Routes.History,
          screens: {
            History: '/history',
          },
        },
      },
    },
    [Routes.UserDetailsForm]: '/user/edit',
    [Routes.NftDetails]: '/nft',
    [Routes.OfferDetails]: '/offer',
    [Routes.SignIn]: '/sign-in',
    [Routes.SignUp]: '/sign-up',
    ApplicationInfo: '/application-info',
    NotFound: '*',
  },
}

// Visit https://reactnavigation.org/docs/configuring-links#playground to see more
export const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [prefix, ...universalLinks],
  config: Platform.OS === WEB ? WEB_LINKS_CONFIG : APP_LINKS_CONFIG,
}
